import { render, staticRenderFns } from "./GraficoPercentual.vue?vue&type=template&id=c00234f4&scoped=true"
import script from "./GraficoPercentual.vue?vue&type=script&lang=js"
export * from "./GraficoPercentual.vue?vue&type=script&lang=js"
import style0 from "../../styles.scss?vue&type=style&index=0&id=c00234f4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00234f4",
  null
  
)

export default component.exports